import { Component, EventEmitter, Input, Output } from '@angular/core'
import { FormArray, FormBuilder, FormGroup } from '@angular/forms'

@Component({
  selector: 'app-company-entity-step',
  templateUrl: './company-entity-step.component.html',
  styleUrls: ['./company-entity-step.component.scss']
})
export class CompanyEntityStepComponent {

  @Input() entities!: FormArray

  @Output() add = new EventEmitter<void>()
  @Output() remove = new EventEmitter<number>()
  @Output() saveAndNext = new EventEmitter<void>()
  @Output() discard = new EventEmitter<void>()

  constructor(private fb: FormBuilder) {}

  get entityControls(): FormGroup[] {
    return this.entities.controls as FormGroup[]
  }

  get f() {
    return this.entities.controls
  }

  getLocationsArray(entityIndex: number): FormArray {
    return this.entities.at(entityIndex).get('locations') as FormArray
  }

  addEntity() {
    this.add.emit()
  }

  removeEntity(index: number) {
    this.remove.emit(index)
  }

  addLocation(entityIndex: number) {
    const locations = this.getLocationsArray(entityIndex)
    locations.push(this.createLocationGroup())
  }

  removeLocation(entityIndex: number, locationIndex: number) {
    const locations = this.getLocationsArray(entityIndex)
    locations.removeAt(locationIndex)
  }

  private createLocationGroup(): FormGroup {
    return this.fb.group({
      locationCode: [''],
      address: this.fb.group({
        doorNo: [''],
        street: [''],
        area: [''],
        city: [''],
        pincode: [''],
        state: [''],
        country: ['']
      })
    });
  }

  next() {
    if (this.entities.valid) {
      this.saveAndNext.emit()
    } else {
      this.entities.markAllAsTouched()
    }
  }
}
